import { render, staticRenderFns } from "./OrderStatus.vue?vue&type=template&id=30c52a0d&scoped=true&functional=true&"
import script from "./OrderStatus.vue?vue&type=script&lang=ts&"
export * from "./OrderStatus.vue?vue&type=script&lang=ts&"
import style0 from "./OrderStatus.vue?vue&type=style&index=0&id=30c52a0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "30c52a0d",
  null
  
)

export default component.exports